import { motion } from "motion/react";
import { cn } from "@/core/helpers/cn.ts";
import { DesignVariant } from "@/domains/estate/slice.ts";
import getDesignVariantImage from "@/domains/estate/helpers/getDesignVariantImage.ts";
import EstateDesignVariantPreview from "@/domains/estate/components/design/EstateDesignVariantPreview.tsx";

type Props = {
  designVariants: DesignVariant[];
  onSelect: (designVariant: DesignVariant) => void;
  className?: string;
};

export default function EstateDesignVariantList({ designVariants, onSelect, className }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, translateX: "100%" }}
      animate={{ opacity: 1, translateX: "none" }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className={cn("flex flex-col gap-1.5", className)}
    >
      {designVariants.map((item) => {
        const previewImg = item.images.find((img) => Boolean(img));

        return (
          <EstateDesignVariantPreview
            key={item.interiorPropId}
            name={item.name}
            isActive={item.isActive}
            onClick={() => onSelect(item)}
            image={getDesignVariantImage(item.uuid, previewImg)}
            price={item.price}
          />
        );
      })}
    </motion.div>
  );
}
